import React, { useState } from 'react';
import { Form, Input, Select, Checkbox } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import {
  SRI_LANKA_PROVINCES,
  SRI_LANKA_DISTRICTS_BY_PROVINCE,
  ALL_SRI_LANKA_DISTRICTS
} from '../../../../Utils/sriLankaGeoData';

const { Option } = Select;
const { TextArea } = Input;

const Section03Address = ({ form }) => {
  const [selectedProvince, setSelectedProvince] = useState(form.getFieldValue('province') || null);
  const [isSameAddress, setIsSameAddress] = useState(form.getFieldValue('isCurrentSameAsPermanent') || false);

  const availableDistricts = selectedProvince
    ? SRI_LANKA_DISTRICTS_BY_PROVINCE[selectedProvince] || []
    : ALL_SRI_LANKA_DISTRICTS;

  const handleProvinceChange = (province) => {
    setSelectedProvince(province);
    form.setFieldsValue({ district: undefined });
  };

  const handleSameAddressChange = (e) => {
    const checked = e.target.checked;
    setIsSameAddress(checked);
    form.setFieldsValue({ isCurrentSameAsPermanent: checked });

    if (checked) {
      const permanent = form.getFieldValue('permanentAddress');
      form.setFieldsValue({ currentAddress: permanent || '' });
    }
  };

  const handlePermanentAddressChange = (e) => {
    if (isSameAddress) {
      form.setFieldsValue({ currentAddress: e.target.value });
    }
  };

  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 03</span>
        <h3>Address Information</h3>
        <p className="section-description">
          Provide your residential and geographical location details for physical correspondence and regional study centers.
        </p>
      </div>

      <div className="form-grid">
        <Form.Item
          label="Permanent Address"
          name="permanentAddress"
          rules={[{ required: true, message: 'Please enter your permanent address' }]}
        >
          <TextArea
            rows={3}
            placeholder="e.g. No. 45/A, Temple Road, Colombo 03"
            onChange={handlePermanentAddressChange}
          />
        </Form.Item>

        <div className="same-address-checkbox-wrapper">
          <Checkbox checked={isSameAddress} onChange={handleSameAddressChange}>
            <strong>Current Address is the same as Permanent Address</strong>
          </Checkbox>
        </div>

        <Form.Item
          label="Current / Residential Address"
          name="currentAddress"
          rules={[{ required: true, message: 'Please enter your current address' }]}
        >
          <TextArea
            rows={3}
            placeholder="e.g. Current boarding, apartment, or residential address"
            disabled={isSameAddress}
          />
        </Form.Item>

        <div className="grid-two-cols">
          <Form.Item
            label="Province"
            name="province"
            rules={[{ required: true, message: 'Please select your province' }]}
          >
            <Select
              size="large"
              placeholder="Select Province"
              onChange={handleProvinceChange}
              showSearch
            >
              {SRI_LANKA_PROVINCES.map((prov) => (
                <Option key={prov} value={prov}>
                  {prov} Province
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="District"
            name="district"
            rules={[{ required: true, message: 'Please select your district' }]}
          >
            <Select size="large" placeholder="Select District" showSearch>
              {availableDistricts.map((dist) => (
                <Option key={dist} value={dist}>
                  {dist}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item
            label="City / Town"
            name="city"
            rules={[{ required: true, message: 'Please enter your city or town' }]}
          >
            <Input prefix={<EnvironmentOutlined />} placeholder="e.g. Kandy, Nugegoda, Galle" size="large" />
          </Form.Item>

          <Form.Item label="Postal Code (Optional)" name="postalCode">
            <Input placeholder="e.g. 10250" size="large" />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default Section03Address;
